import { containersOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

export const conf = defineEntity({
  ...entityFactory("container"),
  endpoint: "containers",
  operations: containersOps,
  roleView: [ROLE.CONTAINER_VIEW, ROLE.CONTAINER_ADMIN],
  roleAdmin: [ROLE.CONTAINER_ADMIN],
  singularName: (t) => t("Container"),
  name: (t) => t("Containers"),
  initialFilter: {
    status: "active",
  },
  syncCustomerFilter: true,
  dependencies: ["region-code"],
  sorterSeparator: "_",
});

export default conf;
